import type {
  CardPaymentContext,
  ParentState,
  PartialParentContext,
} from "@hopper-b2b/checkout";
import type { RequiredField } from "@hopper-b2b/utilities";
import type { RewardsPaymentContext } from "./context";

export interface PartialRewardsParentContext extends PartialParentContext {
  [ParentState.cardPayment]: CardPaymentContext;
  [ParentState.awardsPayment]?: RewardsPaymentContext;
}

export type ParentContextWithRewardsPayment = RequiredField<
  PartialRewardsParentContext,
  ParentState.awardsPayment
>;

export enum RewardsPaymentInformationState {
  loading = "loading",
  idle = "idle",
  error = "error",
}
